<template>
  <div class="bi-action container cbi-action">
    <div>
      <div class="container">
        <div class="row">
          <div class="label mt-2 mb-1 mr-1" v-b-tooltip="'Last update: ' + action.lastUpdate">
            {{ action.name }}
            <i
              v-if="action.isLiveData"
              @click="refreshAction(action.id)"
              class="cursor-pointer fas fa-sync ml-1"
              :class="{ 'fa-spin': loading }"
            ></i>
          </div>
          <div v-if="action.error" class="ml-3 badge badge-danger badge-pill notransition" v-b-popover.hover="action.error">Error</div>
        </div>
      </div>
    </div>

    <ActionResultData :action="action"></ActionResultData>

    <div v-if="action.type === actionType.Get">
      <BoardItemGetAction :action="action"></BoardItemGetAction>
    </div>
    <div v-if="action.type === actionType.Post">
      <BoardItemPostAction :action="action"></BoardItemPostAction>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { Prop } from 'vue-property-decorator';
  import { ActionTypeDto, IBoardItemActionDto } from '@/apiclient/apiclient_generated';
  import BoardItemGetAction from './BoardItemGetAction.vue';
  import ActionResultData from './components/ActionResultData.vue';
  import BoardItemPostAction from './BoardItemPostAction.vue';
  import { BoardStore, BoardModule } from '@/store/board';

  @Component({
    components: {
      BoardItemGetAction,
      BoardItemPostAction,
      ActionResultData
    },
  })
  export default class BoardItemAction extends Vue {
    private boardStore: BoardModule = BoardStore;

    @Prop()
    action: IBoardItemActionDto;
    @Prop()
    boardId: string;

    actionType = ActionTypeDto;
    loading = false;

    async refreshAction(id) {
      this.loading = true;

      await this.boardStore.refreshAction({ id, boardId: this.boardId });
      this.loading = false;
    }
  }
</script>

<style lang="scss">
  .bi-action {
    border: 2px solid #e5e5e5;
    margin-bottom: 10px;

    .badge {
      padding-top: 4px;
      height: 16px;
      margin-top: 9px;
    }

    .refresh {
      padding-top: 3px;
      height: 20px;
      margin-top: 7px;
      margin-left: 10px;
    }
  }
</style>
